export var DECIMAL = "decimal";
export var CURRENCY = "currency";
export var ACCOUNTING = "accounting";
export var PERCENT = "percent";
export var SCIENTIFIC = "scientific";

export var CURRENCY_PLACEHOLDER = "$";
export var PERCENT_PLACEHOLDER = "%";
export var NUMBER_PLACEHOLDER = "n";

export var LIST_SEPARATOR = ";";
export var GROUP_SEPARATOR = ",";

export var POINT = ".";
export var EMPTY = "";

export var DEFAULT_LOCALE = "en";




//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/common/constants.js
// module id = 33
// module chunks = 93